var _rect, _path, _path2, _path3, _polygon, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Electric Vehicle Charger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 5.4,
    className: "st0",
    width: 1.5,
    height: 3.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6,4.6h-4.4L9.9,0.3H5.7v3H0v1.5h5.7v5.5H0v1.5h5.7v2.4h4.2l3.3-4.3h4.4L17.6,4.6z M16.2,8.5h-3.8l-3.3,4.4 H7.2V1.7h1.9l3.3,4.4h3.8V8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3,32c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2C14.5,33.4,13.1,32,11.3,32z M11.3,36.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C12.9,36,12.2,36.7,11.3,36.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9,32c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2C41.1,33.4,39.7,32,37.9,32z M37.9,36.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C39.5,36,38.8,36.7,37.9,36.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24,22.6 25.9,23.4 23.3,29.5 29.4,29.5 24.9,37.7 23.1,36.9 26,31.5 20.5,31.5 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48,12.4c0-3.6-2.9-6.5-6.5-6.5l-21.8,0l0-0.9h-1.5l0,3.8h1.5l0-1l21.8,0c2.6,0,4.6,2.1,4.6,4.6 c0,2.6-2.1,4.6-4.6,4.6H15.4c-1.7,0-3.2,1.2-3.6,2.8l-2.1,8.6h-2c-2,0-3.7,1.7-3.7,3.7v6.1c0,2,1.7,3.7,3.7,3.7h1.9v4.9 c0,0.5,0.4,0.9,0.9,0.9H16c0.5,0,0.9-0.4,0.9-0.9v-4.9h15.4v4.9c0,0.5,0.4,0.9,0.9,0.9h5.6c0.5,0,0.9-0.4,0.9-0.9v-4.9h1.9 c2,0,3.7-1.7,3.7-3.7v-6.1c0-2-1.7-3.7-3.7-3.7h-2l-2.1-8.6c-0.1-0.3-0.2-0.7-0.4-1h4.5C45.1,18.8,48,15.9,48,12.4z M15,45.9h-3.7 v-4H15V45.9z M37.8,45.9h-3.7v-4h3.7V45.9z M37.6,28.4h-5.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h9.2c1,0,1.9,0.8,1.9,1.9 v6.1c0,1-0.8,1.9-1.9,1.9H7.6c-1,0-1.9-0.8-1.9-1.9v-6.1c0-1,0.8-1.9,1.9-1.9h9.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-5.3 l2-8.1c0.2-0.8,0.9-1.4,1.8-1.4h18.4c0.9,0,1.6,0.6,1.8,1.4L37.6,28.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleCharger);
export default __webpack_public_path__ + "static/media/vehicle-charger.71f5da554a6a0ee9c429ab3a5de1ce06.svg";
export { ForwardRef as ReactComponent };